import {requests} from "../../utils/helpers/api.services";
import {EARNINGS_URL} from "../../utils/helpers/api.routes";

export const EarningsService = {
    getEarnings: (params: any) => requests.get(EARNINGS_URL, params),
    createEarning: (body: { month: number, year: number, revenue: number }) => requests.post(EARNINGS_URL, body),
    updateEarning: (body: { month: number, year: number, revenue: number }, id: number) => requests.put(`${EARNINGS_URL}/${id}`, body),
    deleteEarning: (id: number) => requests.delete(`${EARNINGS_URL}/${id}`)
}